var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProofreadVoiceSelectSoundWave = function SvgIconProofreadVoiceSelectSoundWave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.291 8.283v3.437m3.083-6.014v8.592M8.458 2.699v14.605M11.54 5.945v8.113m3.083-6.085v4.057m3.084-2.887v1.718"
  })));
};
export default SvgIconProofreadVoiceSelectSoundWave;